<template>
    <div>
      <div class="title-box">
            车间信息表
        </div>
        <!-- 查询条件 -->
        <el-form id="formID" :inline="true" :model="queryParams" style="border-radius:3px;margin-bottom:10px; box-shadow:0px 1px 0px 0px rgba(0, 0, 0, 0.1);" class="demo-form-inline">
            <el-form-item>
                <el-select v-model="queryParams.factoryId" filterable placeholder="选择工厂" clearable>
                    <el-option
                    v-for="item in factoryOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-input v-model="queryParams.workshopName" placeholder="输入车间" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item>
                <el-select v-model="queryParams.scene" filterable placeholder="选择场景">
                    <el-option
                    v-for="item in sceneOpt"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="info" @click="onReset">重置</el-button>
            </el-form-item>
            <!-- 添加按钮 -->
            <span style="position:relative;float:right;bottom:14px;">
                <i v-hasPermi="['enterpr:workshop:add']" style="background:#C7C7C7;color:#fff;cursor:pointer;width:32px;height:32px;text-align:center;margin-top:18px;padding-top:7px;border-radius:3px" @click="openDialog()" class="el-icon-plus"></i>
            </span>
        </el-form>
        
        <!-- 表格 -->
        <el-table :data="tableData" border :style="{ height: tableHeight + 'px',width:'100%','border-radius':'3px'}">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column v-if="false" type="id" label="id" align="center"></el-table-column>
            <el-table-column prop="factoryName" label="所属工厂" width="150" align="center"></el-table-column>
            <el-table-column prop="workshopNo" label="车间编号" width="150"  align="center"></el-table-column>
            <el-table-column prop="workshopName" label="车间名称" width="150" align="center"></el-table-column>
            <el-table-column prop="fileId" label="车间平面图" width="100" align="center">
                <template #default="scope">
                    <el-button v-if="scope.row.fileId" @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="workshopDescription" label="车间描述" width="100" align="center"></el-table-column>
            <el-table-column prop="remark" label="备注" align="center"></el-table-column>
            <el-table-column prop="updateByName" label="修改人" align="center"></el-table-column>  
            <el-table-column prop="updateTime" label="修改时间" align="center"></el-table-column>
            <el-table-column label="操作" width="90" align="center">
                <template slot-scope="scope">
                    <el-button v-hasPermi="['enterpr:workshop:edit']" style="color:#3083FB !important;" @click="handleEdit(scope.$index,scope.row)" type="text" size="small">修改</el-button>
                    <el-button v-hasPermi="['enterpr:workshop:remove']" style="color:#3083FB !important;" @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="background:#fff;text-align:center;padding:20px 0;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="queryParams.pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

        <!-- 添加 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="615px" center :close-on-click-modal="false">
            <el-form ref="ruleForm" :model="dialogForm" :rules="rules" label-width="80px" style="padding:0;" :inline="true">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="工厂名称" prop="factoryId">
                            <el-select v-model="dialogForm.factoryId" filterable placeholder="工厂名称" clearable>
                                <el-option
                                v-for="item in factoryOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="车间编号" prop="workshopNo">
                            <el-input placeholder="请输入车间编号" v-model="dialogForm.workshopNo" clearable>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="车间名称" prop="workshopName">
                            <el-input placeholder="请输入车间名称" v-model="dialogForm.workshopName" clearable>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="车间描述" prop="workshopDescription">
                            <el-input placeholder="请输入车间描述" v-model="dialogForm.workshopDescription" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="备注" prop="remark" style="width:100%;">
                            <el-input placeholder="请输入备注" v-model="dialogForm.remark" clearable style="width:485px;"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="车间平面图" prop="fileId">
                            <el-upload
                                ref="fileUploadRef"
                                class="upload-demo"
                                :action="uploadImgUrl"
                                :headers="headers"
                                :on-success="handleSuccess"
                                :before-upload="beforeUpload"
                                :show-file-list="false"
                                :on-exceed="handleExceed"
                                :limit="limit"
                                :file-list="fileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                            <!-- 上传提示 -->
                            <div v-if="showTip" class="el-upload__tip">
                                请上传
                                <template v-if="fileSize">
                                    大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b>
                                </template>
                                <template v-if="fileType">
                                    格式为 <b style="color: #f56c6c">{{ fileType.join('/') }}</b>
                                </template>
                                的文件
                            </div>
                            <!-- 文件列表 -->
                            <transition-group class="upload-file-list el-upload-list el-upload-list--text" name="el-fade-in-linear" tag="ul">
                                <li v-for="(file, index) in fileList" :key="file.ossId" class="el-upload-list__item ele-upload-list__item-content">
                                    <el-link :href="`${file.url}`" :underline="false" target="_blank">
                                    <span class="el-icon-document"> {{ getFileName(file.name) }} </span>
                                    </el-link>
                                    <!-- <div class="ele-upload-list__item-content-action"> -->
                                    <el-button type="danger" size="mini" link @click="handleDeleteFile(index)" style="margin-left:5px;padding: 4px 8px;">删除</el-button>
                                    <!-- </div> -->
                                </li>
                            </transition-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" style="color:#000 !important;">取 消</el-button>
                <el-button type="primary" @click="handleAdd('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 查看 -->
        <el-dialog title="查看" :visible.sync="pdfVisible" width="615px" center>
            <iframe :src="scenePdf" width="100%" height="500px" frameborder="0"></iframe>
        </el-dialog>
    </div>
</template>
<script>
import { Message, MessageBox} from 'element-ui'
export default {
    data(){
        return{
            // 查询条件
            queryParams: {
                pageNum:1,
                pageSize: 10,
                factoryId:"",
                workshopName:""
            },
            dialogTitle:"",
            dialogForm:{},
            fileUploadRef:null,
            fileList: [], // 用于存储已上传的文件列表，可选，主要用于显示已上传的文件列表和删除功能
            showTip:true,
            fileSize:false,
            fileType:["pdf"],
            //工厂数据
            factoryOptions: [],
            total:0,
            tableHeight:300,
            // 表格数据
            tableData:[],
            dialogFormVisible:false,//是否显示添加对话框
            rules:{
                factoryId:[{ required: true, message: '工厂名称不能为空', trigger: 'change' }],
                workshopNo:[{ required: true, message: '车间编号不能为空', trigger: 'blur' }],
                workshopName:[{ required: true, message: '车间名称不能为空', trigger: 'blur' }]
            },
            uploadImgUrl:process.env.VUE_APP_BASE_API + '/resource/oss/upload', // 上传的图片服务器地址
            uploadList:[],
            number:0,
            headers:null,
            limit:1,
            scenePdf:"",
            pdfVisible:false

        }
    },
    async mounted() {
        const VUE_APP_LOCALSTORAGE_TOKEN_NAME = process.env.VUE_APP_LOCALSTORAGE_TOKEN_NAME;
        const localStorageToken = localStorage.getItem(VUE_APP_LOCALSTORAGE_TOKEN_NAME);
        this.headers = {
                Authorization: 'Bearer ' + localStorageToken,
                clientid: process.env.VUE_APP_CLIENT_ID
            };
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        this.getList();   
        await this.getFactoryByCustomer();   
        let query = this.$route.query;  
        if(query&&query.id){
            this.dialogFormVisible = true;
            this.dialogTitle = "车间信息添加";
            this.dialogForm.factoryId = query.id;
        }
    },
    methods: {
        // 获取车间信息列表
        getList(){
            this.$store.dispatch("workshop/getWorkshopList",this.queryParams).then((result)=>{
                if(result?.rows){
                    this.tableData = result.rows;
                    this.total = result.total;
                }
                else{
                    this.tableData = [];
                    this.total = 0;
                }
            });
        },
        // 根据客户查询工厂
        getFactoryByCustomer(){
            this.$store.dispatch("workshop/getFactoryByCustomer",this.queryParams).then((result)=>{
                if(result?.data){
                    this.factoryOptions = result.data;
                }
                else{
                   this.factoryOptions = []; 
                }
            });
        },
        // 表单重置
        reset(){
            this.dialogForm = {
                factoryId:null,
                workshopNo:"",
                workshopName:"",
                workshopDescription:"",
                fileId:"",
                remark:""
            };
        },
        // 监听窗口缩放
        handleResize(){
            // 当窗口大小变化时，这个函数会被调用
            const height = window.innerHeight;
            let dom = document.getElementById("formID");
            let formH = 70;//一行时高度为70
            if(dom){
                formH = dom.offsetHeight;
            }
            this.tableHeight = height-191-formH;//表单的高度会变化

            let tableBody = document.getElementsByClassName("el-table__body-wrapper")[0];
            if(tableBody){
                tableBody.style.height = (this.tableHeight-40)+"px";
            }
        },
        // 查询
        onSubmit() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        // 重置
        onReset(){
            this.queryParams = {
                pageNum:1,
                pageSize: 10,
                factoryId:"",
                workshopName:""
            };
            this.getList();
        },
        // 查看车间平面图
        handleClick(row){
            if(row.fileId){
                this.pdfVisible = true;
                // 跳转到平面图页面
                this.$store.dispatch("oss/getOssDetail",{ossId:row.fileId}).then((res)=>{
                    if(res?.data?.url){
                        let data = res.data;
                        this.scenePdf = data.url;
                    }
                })
            }
        },
        // 行修改
        handleEdit(index,row) {
            this.dialogFormVisible = true;
            this.dialogTitle="车间信息修改";
            this.reset();
            this.$store.dispatch('workshop/getWorkshop',{id:row.id}).then((result)=>{
                if(result&&result.data){
                    this.dialogForm = result.data;
                    if(result.data.fileId){
                        this.fileList = [];
                        this.$store.dispatch("oss/getOssDetail",{ossId:result.data.fileId}).then((res)=>{
                            let data = res.data;
                            this.fileList.push({
                                ossId:data.ossId,
                                url:data.url,
                                name:data.originalName
                            })
                        })
                    }
                }
            });
        },
        // 行删除
        handleDelete(row) {
            const workshopids = row?.id;
            const workshopNames = row?.workshopName;
            MessageBox.confirm('是否确认删除车间“' + workshopNames + '”的数据', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('workshop/deleteWorkshop',{ids:workshopids}).then((result)=>{
                    if(result){
                        this.getList();
                        Message.success('删除成功');
                    }
                }); 
            }).catch(() => {          
            });
        },
        // 上传结束处理
        uploadedSuccessfully(){
            if (this.number > 0 && this.uploadList.length === this.number) {
                this.fileList = this.fileList.filter((f) => f.url !== undefined).concat(this.uploadList);
                this.uploadList = [];
                this.number = 0;
                // emit('update:modelValue', listToString(this.fileList));
                // proxy?.$modal.closeLoading();
            }
        },
        // 上传成功
        handleSuccess(res, file) {
            if (res.code === 200) {
                this.uploadList.push({
                    name: res.data.fileName,
                    url: res.data.url,
                    ossId: res.data.ossId
                });
            } else {
                this.number--;
                // proxy?.$modal.closeLoading();
                Message.error(res.msg);
                this.fileUploadRef?.handleRemove(file);
            }
            this.uploadedSuccessfully();
        },
        beforeUpload(file) {
            // 校检文件类型
            // if (this.fileList.length) {
                const fileName = file.name.split('.');
                const fileExt = fileName[fileName.length - 1];
                const isTypeOk = this.fileType.indexOf(fileExt) >= 0;
                if (!isTypeOk) {
                // this.proxy?.$modal.msgError(`文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`);
                    Message.error(`文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`);
                    return false;
                }
            // }
            // 校检文件大小
            if (this.fileSize) {
                const isLt = file.size / 1024 / 1024 < this.fileSize;
                if (!isLt) {
                // proxy?.$modal.msgError(`上传文件大小不能超过 ${props.fileSize} MB!`);
                    Message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
                    return false;
                }
            }
            // proxy?.$modal.loading('正在上传文件，请稍候...');
            this.number++;
            return true;
        },
        // 文件个数超出
        handleExceed(){
            // proxy?.$modal.msgError(`上传文件数量不能超过 ${props.limit} 个!`);
            Message.error(`上传文件数量不能超过${this.limit}个!`);
        },
        // 获取文件名称
        getFileName(name){
            if(name){
                // 如果是url那么取最后的名字 如果不是直接返回
                if (name.lastIndexOf('/') > -1) {
                    return name.slice(name.lastIndexOf('/') + 1);
                } else {
                    return name;
                }
            }
        },
        // 删除文件
        handleDeleteFile(index){
            let ossId = this.fileList[index].ossId;
            this.$store.dispatch('oss/delOss',{ossId:ossId});
            this.fileList.splice(index, 1);
        },
        // 添加按钮
        openDialog(){
            // addWorkshop
            this.dialogFormVisible = true;
            this.dialogTitle="车间信息添加";
            this.reset();
        },
        // 确认添加
        handleAdd(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let arr = [];
                    for(let i=0;i<this.fileList.length;i++){
                        arr.push(this.fileList[i].ossId);
                    }
                    this.dialogForm.fileId = arr.join(",");//数组转换成字符串
                    if(this.dialogForm.id){//修改
                        this.$store.dispatch("workshop/editWorkshop",this.dialogForm).then(()=>{
                            this.getList();
                        });
                    }
                    else{//新增
                        this.$store.dispatch("workshop/addWorkshop",this.dialogForm).then(()=>{
                            this.getList();
                        });
                    }
                    this.dialogFormVisible = false;
                } else {
                    return false;
                }
            });
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        }
    }
}
</script>

<style lang="scss" scoped>
    .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
    // 表头背景色
    ::v-deep .custom-table-header th{
        background-color: #ebeef5 !important;
    }
    // 表格字体大小
    .el-table {
        font-size: 12px;
    }
    // 表单底部边界线
    .el-table::before {
        height: 0px;
    }
    // 表格字体
    ::v-deep .el-table thead {
        color: #606266;
    }
    // 表格内边距
    ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
    }
    // 表单底部margin
    .el-form-item {
        margin-bottom: 0;
    }
    .el-row{
        padding-bottom: 10px;
    }
    ::v-deep .el-form-item__error{
        padding-top: 0;
    }
    // 当前页码样式
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #FF9F07;
    }
    // 页面hover样式
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #FF9F07;
    }
    ::v-deep .el-dialog{
        border-radius: 5px;
    }
    ::v-deep .el-dialog__header {
        padding: 6px 19px;
        background: #B1CEF9;
        font-size: 16px;
        font-weight: bold;
        text-align: left;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }   
    ::v-deep .el-dialog__headerbtn {
        font-size: 18px;
    }
    ::v-deep .el-dialog__headerbtn {
        top: 10px;
        right: 6px;
    }
    ::v-deep .el-dialog__body {
        padding: 15px 20px;
        border-bottom: 1px solid #D5D5D5;
    }
    ::v-deep .el-form-item__label {
        font-size: 12px;
    }
    ::v-deep .el-dialog__footer {
        padding: 20px;
    }
    ::v-deep .el-table__body-wrapper{
        overflow-y: auto;
    }
    // 表格列数据太长时显示省略号
    ::v-deep .el-table .cell {
        word-break: keep-all;
    }
    #formID .el-row{
        height: 40px;
        padding-bottom: 0;
    }
</style>